import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiDelete, operationsClient } from '@/lib/api';
import { appointmentEndpoints } from '@/lib/api/endpoints';
import { jobKeys } from '@/lib/queryKeys';

interface Vars {
  appointmentId: string;
  snapshotId: string;
}

/**
 * DELETE /appointments/:id/additional-items/:snapshotId — drop a per-visit item.
 */
export function useRemoveAdditionalItem(jobId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<unknown, Vars>({
    mutationFn: ({ appointmentId, snapshotId }) =>
      apiDelete(operationsClient, appointmentEndpoints.additionalItem(appointmentId, snapshotId)),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: jobKeys.appointments(jobId) });
      toast.success('Item removed');
    },
  });
}
